import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { RuleBusinessType, RuleImplementationType } from "src/types/rule";

export const RULES_BUSINESS_TYPE_LABELS: Record<RuleBusinessType, LocaleKeys> = {
  comparison: "page.rules.advanced.modal.create.form.businessType.comparison",
  velocity: "page.rules.advanced.modal.create.form.businessType.velocity",
  linkedCase: "page.rules.advanced.modal.create.form.businessType.linkedCase",
  blacklist: "page.rules.advanced.modal.create.form.businessType.blacklist",
  caseProperties: "page.rules.advanced.modal.create.form.businessType.caseProperties",
};

export const RULE_IMPLEMENTATION_TYPE_LABELS: Record<RuleImplementationType, LocaleKeys> = {
  predefined: "page.rules.implementationType.predefined",
  userDefined: "page.rules.implementationType.userDefined",
};
